/**
 * Defines an interface (with default implementation) for translating property values between their
 * representation within the peer model and that used within the UIContainer.  Most properties need no
 * translation.  Translators are only defined for those that do.
 *
 * @copyright Copyright 2018 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare",
    "dojo/_base/lang"
], function (declare, lang) {
    var PropertyTranslator = declare([], {

        postscript: function(args){
            if (args) {
                lang.mixin(this, args);
            }
        },

        /**
         * Translates a value from its UIContainer representation to its peer model representation.
         */
        toPeer: function (value) {
            return value;
        },

        /**
         * Translates a value from its peer model representation to its UIContainer representation.
         */
        fromPeer: function (value) {
            return value;
        }
    });

    PropertyTranslator.ForceArray = new PropertyTranslator({
        fromPeer: function (value) {
            if (value && !Array.isArray(value)) {
                value = [value];
            }
            return value;
        }
    });

    return PropertyTranslator;
});